import i18n from "i18next"
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEn from './translation.en'
import translationKo from './translation.ko'

const resource =  {
    en: {
        translation: translationEn
    },
    ko: {
        translation: translationKo
    }
};

const DETECTION_OPTIONS = {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage']
};
i18n
    .use(LanguageDetector).use(initReactI18next).init({
        resources: resource,
        detection: DETECTION_OPTIONS,
        fallbackLng: 'kr',
        ns: 'translation',
        defaultNS: "translation",
        //debug: true,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        },
        react : {
            wait: true,
        },
    });

    i18n.languages = ['kr','en']
export default i18n;
